// 当前页面作为类型字典存在

// 组织类型
const org = [
  {
    name: '无组织类型',
    id: 0
  },
  {
    name: '教育局',
    id: 1
  },
  {
    name: '校管辖单位',
    id: 2
  },
  {
    name: '机构',
    id: 3
  },
  {
    name: '学校',
    id: 4
  },
  {
    name: '校区',
    id: 5
  },
  {
    name: '学段',
    id: 6
  },
  {
    name: '年段',
    id: 7
  },
  {
    name: '班级',
    id: 8
  },
  {
    name: '行政部门',
    id: 9
  }
]

// 学校状态
const schoolStatus = [
  {
    name: '开启',
    id: 1
  },
  {
    name: '关闭',
    id: 0
  }
]

// 性别
const gender = [
  {
    name: '男',
    id: 0
  },
  {
    name: '女',
    id: 1
  }
]

// 身份
const identity = [
  {
    name: '学生',
    id: 0
  },
  {
    name: '教职工',
    id: 1
  }
]

// 学校类型
const schoolType = [
  {
    name: '幼儿园',
    id: '幼儿园'
  },
  {
    name: '小学',
    id: '小学'
  },
  {
    name: '初级中学',
    id: '初级中学'
  },
  {
    name: '高级中学',
    id: '高级中学'
  },
  {
    name: '完全中学',
    id: '完全中学'
  },
  {
    name: '九年一贯制学校',
    id: '九年一贯制学校'
  },
  {
    name: '十二年一贯制学校',
    id: '十二年一贯制学校'
  },
  {
    name: '全学制学校',
    id: '全学制学校'
  },
  {
    name: '中等职业学校',
    id: '中等职业学校'
  },
  {
    name: '特殊学校',
    id: '特殊学校'
  },
  {
    name: '大学',
    id: '大学'
  },
  {
    name: '其他',
    id: '其他'
  }
]

// 办学性质
const schoolNature = [
  {
    name: '公办',
    id: '公办'
  },
  {
    name: '民办',
    id: '民办'
  },
  {
    name: '其他',
    id: '其他'
  }
]

// 办学形式
const schoolForm = [
  {
    name: '非寄宿制',
    id: '非寄宿制'
  },
  {
    name: '部分寄宿制',
    id: '部分寄宿制'
  },
  {
    name: '完全寄宿制',
    id: '完全寄宿制'
  }
]

// 学段类型
const leanPhaseType = [
  {
    name: '幼儿园',
    id: '幼儿园'
  },
  {
    name: '小学',
    id: '小学'
  },
  {
    name: '初中',
    id: '初中'
  },
  {
    name: '高中',
    id: '高中'
  },
  {
    name: '中职',
    id: '中职'
  },
  {
    name: '特殊教育',
    id: '特殊教育'
  },
  {
    name: '毕业班',
    id: '毕业班'
  },
  {
    name: '非毕业班',
    id: '非毕业班'
  },
  {
    name: '无学段',
    id: '无学段'
  },
  {
    name: '成人',
    id: '成人'
  }
]

// 年段名称
export const periodOfName = {
  幼儿园: ['小小班', '小班', '中班', '大班', '学前班'],
  幼儿园_Key: ['小班', '中班', '大班'],
  小学: ['小学一年级', '小学二年级', '小学三年级', '小学四年级', '小学五年级', '小学六年级', '小学七年级', '小学八年级', '小学九年级', '小学十年级'],
  初中: ['初中一年级', '初中二年级', '初中三年级', '初中四年级', '初中五年级', '初中六年级'],
  高中: ['高中一年级', '高中二年级', '高中三年级', '高中四年级', '高中五年级', '高中六年级'],
  中职: ['中职一年级', '中职二年级', '中职三年级', '中职四年级', '中职五年级', '中职六年级'],
  特殊教育: ['特殊教育一年级', '特殊教育二年级', '特殊教育三年级', '特殊教育四年级', '特殊教育五年级', '特殊教育六年级', '特殊教育七年级', '特殊教育八年级', '特殊教育九年级', '特殊教育十年级'],
  毕业班: ['毕业班'],
  非毕业班: ['非毕业班'],
  无学段: ['无学段'],
  成人: ['成人']
}

export const gradeAppenObj = {
  幼儿园: ['幼小', '幼中', '幼大'],
  小学: ['一年级', '二年级', '三年级', '四年级', '五年级', '六年级'],
  初中: ['初一', '初二', '初三'],
  高中: ['高一', '高二', '高三'],
  特殊: ['七年级', '八年级', '九年级']
}

// 年段显示类型
export const yearDisplayType = {
  幼儿园: [{ value: 0, label: '按幼儿园年级格式显示' }, { value: 1, label: '按幼小格式显示' }],
  小学: [{ value: 0, label: '按小学一年级格式显示' }, { value: 1, label: '按一年级格式显示' }],
  初中: [{ value: 0, label: '按初中一年级格式显示' }, { value: 1, label: '按初一格式显示' }, { value: 2, label: '按七年级格式显示' }],
  高中: [{ value: 0, label: '按高中一年级格式显示' }, { value: 1, label: '按高一格式级显示' }]
}

const middleSchoolConversionType = {
  初一: '七年级',
  初二: '八年级',
  初三: '九年级',
  初四: '十年级',
  初五: '十一年级',
  初六: '十二年级'
}

// 身份类型
const identityTypes = [
  {
    name: '居民身份证',
    id: 1
  },
  {
    name: '香港特区护照/身份证明',
    id: 2
  },
  {
    name: '澳门特区护照/身份证明',
    id: 3
  },
  {
    name: '台湾居民来往大陆通行证',
    id: 4
  },
  {
    name: '境外永久居住证',
    id: 5
  },
  {
    name: '其他',
    id: 6
  }
]

// 账号状态
const userStatus = [
  {
    name: '激活',
    id: 1
  },
  {
    name: '不激活',
    id: 0
  }
]

export default {
  org,
  schoolStatus,
  gender,
  identity,
  identityTypes,
  schoolType,
  schoolNature,
  schoolForm,
  leanPhaseType,
  periodOfName,
  userStatus,
  yearDisplayType,
  middleSchoolConversionType,
  gradeAppenObj
}
